<template>
	<div>

        <v-toolbar flat fixed>
            <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
            <v-toolbar-title class="white--text">Data Backup</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-menu bottom left>
                <v-btn small nopadding slot="activator" icon>
                    <v-icon font20>more_vert</v-icon>
                </v-btn>

                <v-list dense nopadding @click.native="fn_dataBackups">
                    <v-list-tile>
                      <v-list-tile-title>Archived Databases</v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-menu>
        </v-toolbar>

        <div class="hasToolbar">
            <v-alert type="info" :value="true">
                Backup your data to google drive. You can restore them when you reinstall this app.
            </v-alert>

            <v-card noshadow padding-bottom-ten>

                <!-- {{testdate | moment("DD-MMM-YYYY h:mm a")}} -->

                <v-list nopadding two-line>
                    <!-- <v-list-tile v-ripple @click="fn_dataBackups">

                          <v-list-tile-content>
                            <v-list-tile-title>Data Backups</v-list-tile-title>
                            <v-list-tile-sub-title>Recent data backups</v-list-tile-sub-title>
                          </v-list-tile-content>

                          <v-list-tile-action>
                              <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                          </v-list-tile-action>
                      </v-list-tile>

                      <v-divider></v-divider> -->

                    <v-list-tile>

                        <v-list-tile-content>
                            <v-list-tile-title>Last BackUp</v-list-tile-title>

                            <div v-if="loading">
                                <v-list-tile-sub-title>Getting last backup details...</v-list-tile-sub-title>
                            </div>

                            <div v-else>
                                <v-list-tile-sub-title v-if="!lastBackupTime">
                                    No last backup, backup now
                                </v-list-tile-sub-title>

                                <v-list-tile-sub-title v-if="lastBackupTime">
                                    Last Backup to Google Drive: 
                                    {{lastBackupTime | moment("DD-MMM-YYYY h:mm a")}}
                                </v-list-tile-sub-title>
                            </div>

                            

                        </v-list-tile-content>

                    </v-list-tile>

                    <div class="pr-3 pl-3" grey-color>
                        <p>Backup your data to Google Drive. You can restore them when you reinstall the app and signin with Google Account.</p>

                        <v-btn color="primary" nomargin :disabled="$root.backupInProgress || loading" @click="fn_prepareDataToBackup">Backup Now</v-btn>
                    </div>

                    <div class="pr-3 pl-3" v-if="$root.backupInProgress">
                        <v-progress-linear indeterminate class="mt-2 mb-2" v-if="!$root.uploadStatus || $root.uploadStatus==100"></v-progress-linear>
                        <v-progress-linear v-model="$root.uploadStatus" :buffer-value="100" buffer v-else></v-progress-linear>
                        <span v-if="!$root.uploadStatus">Preparing data to backup...</span>
                        <span v-if="$root.uploadStatus && $root.uploadStatus!=100">{{$root.uploadStatus+'%'}}</span>
                        <span v-if="$root.uploadStatus==100">Finishing data backup...</span>
                    </div>

                </v-list>
            </v-card>

            <v-divider></v-divider>

            <v-card noshadow>
                <v-subheader>Backup Drive Settings</v-subheader>
                <v-list nopadding two-line>
                    <v-list-tile>

                        <!-- <v-list-tile-action><v-icon>autorenew</v-icon></v-list-tile-action> -->

                        <v-list-tile-content>
                            <!-- <v-list-tile-title>Backup Drive<v-icon>arrow_drop_down</v-icon></v-list-tile-title> -->
                            <v-list-tile-title>Backup Drive</v-list-tile-title>
                            <v-list-tile-sub-title v-if="$root.CurrentBusiness">{{$root.CurrentBusiness.DataDrive}}</v-list-tile-sub-title>
                        </v-list-tile-content>

                    </v-list-tile>

                </v-list>

                <div class="ml-2" @click="fn_checkIsBackupRunning"><v-chip class="ma-0 ml-1" rounded small>Change Backup Drive <v-icon>arrow_drop_down</v-icon></v-chip></div>

                
            </v-card>


        </div>

        <dialog-confirmation ref="ref_dialogConfirmation" header="Change Backup Drive?" :actionMethod="fn_confirmChangeDataDrive"></dialog-confirmation>

        <dialog-business-name ref="ref_dialogBusinessName" header="Change Backup Drive"></dialog-business-name>
	</div>
</template>

<script>

const dialogjs =  require('../../masters/forms/dialog').dialogjs;
import dialogConfirmation from '../../dialogs/dialog_confirmation'
import dialogBusinessName from '../../dialogs/dialog_business_name'
import {authMixin} from '../auth_mixin'

  export default{
    mixins: [authMixin],
    data(){
        return{
            backupTime:'11:00',
            display_12_hour_time:'11:00 am',
            lastBackupTime:null,
            loading:true,
            formId:null,
            dialogStorageId:null,
            directClose:false
        }
    },

    components:{
        'dialog-confirmation': dialogConfirmation,
        'dialog-business-name': dialogBusinessName
    },

    methods:{

        fn_dataBackups: function(){
            if(!navigator.onLine){
              this.showToast("Internet not available");
            }
            else if(!this.$root.CurrentBusiness.DataDrive){
              this.showToast("No data backups. Please set up backup drive for data backup");
            }
            else{
              this.$router.push({path:"/settings/backup/items"});
            }
        },

        fn_openDialogWeb: function (platform, name, ref) {

            let scroll_y = window.scrollY;
            this.fn_fixBackgroundScroll();

            var dialogObj = {};
            dialogObj.tagId = this.guidWeb();
            dialogObj.formId = this.formId;
            dialogObj.name = name;
            dialogObj.ref = ref;
            dialogObj.data = null;
            dialogObj.platform = platform;

            dialogObj.scrollPosition = {};
            dialogObj.scrollPosition.x = 0;
            dialogObj.scrollPosition.y = scroll_y;

            dialogjs.fn_pushDialogInStack(this.dialogStorageId, dialogObj, this);

            let self = this;

            this.$refs[ref].openDialogWeb();
        },

        fn_closeDialog: function (dontRemove) {
            dialogjs.fn_checkAndCloseOpenDialogs(this);
        },

        fn_scheduleBackupTime: function(){
            let element = document.getElementById('backuptime');
            element.click();
        },

        fn_prepareDataToBackup: function(){

            if(!navigator.onLine){
                this.showToast('Internet not available');
                return;
            }

            this.$root.uploadStatus = 0;

            let self = this;
            this.showLoading('Preparing data to backup...');
            this.getData('PrepareBackupData', this.$root.CurrentBusiness.BusinessID, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        self.hideLoading();
                        self.fn_reopenDatabase(null, true);
                    },
                    onError: function(error){
                        console.log(error);
                        self.hideLoading();
                        self.showToast('Something went wrong. Try again');
                    }
                }
            );
        },

        // reopening db as puran closing db before preparing data for backup
        fn_reopenDatabase: function(dataDrive, backupData){
            let self = this;
            this.getData('ReopenDataBase', this.$root.CurrentBusiness.BusinessID, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        if(dataDrive){
                            self.$root.fn_getAuthToken(function(token){
                                self.fn_changeDataDrive(dataDrive, token);
                            }); 
                        }
                        else if(backupData){
                            self.fn_backupData();    
                        }
                    }, 
                    onError: function(error){
                        console.log(error);
                        self.hideLoading();
                        self.showToast('Something went wrong. Try again');
                    }
                }
            );
        },

        fn_backupData: function(){
            var self = this;
            this.$root.backupInProgress = true;
            this.getData('BackupData', this.$root.CurrentBusiness.BusinessID, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        self.$root.backupInProgress = false;
                        self.$root.uploadStatus = null;
                        self.fn_getLastBackupInfo(1);
                        self.showToast('Data backup complete');
                        self.directClose = false;
                    },
                    onError: function(error){
                        console.log(error);
                        self.$root.backupInProgress = false;
                        self.$root.uploadStatus = null;
                        self.showToast('Something went wrong. Try again');
                    }
                }
            );
        },

        fn_getLastBackupInfo: function(fromBackupSuccess){
            let self = this;
            this.getData('LastBackupTime', this.$root.CurrentBusiness.BusinessID, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        let date = JSON.parse(response);
                        if(date){
                            // let d = new Date(date);
                            // d.setHours(d.getHours() - 5); 
                            // d.setMinutes(d.getMinutes() - 30);
                            self.lastBackupTime = date;

                            // setting backup check flags if databackup successfully done
                            if(fromBackupSuccess){
                                self.$root.lastBackupDate = date;
                                self.$root.lastBackupBefore = 0;
                            }
                        }
                        self.loading = false;
                    }, 
                    onError: function(error){
                        console.log(error);
                        self.loading = false;
                    }, 
                }
            );
        },

        // fn_setUploadStatus: function(status){
        //     this.$root.uploadStatus = status;
        // },

        fn_checkIsBackupRunning: function(){

            if(!navigator.onLine){
                this.showToast('Internet not available');
                return;
            }

            let isBackupRunning = JSON.parse(AndroidRoutingTest.isBackupRunning());
            if(isBackupRunning){
                this.showToast("Data backup under processing");
            }
            else{
                this.fn_openSecurityLock();
                // this.fn_openDialogConfirmation();
            }
        },

        fn_openSecurityLock: function(){
            let self = this;
            this.getData('VerifyScreenLock', null, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        let status = JSON.parse(response);
                        if(status){
                            self.fn_openDialogMatchBusiness();    
                        }
                    },
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },

        fn_openDialogMatchBusiness: function(){
            this.fn_openDialogWeb('web', 'MatchBusinessNameDialog', 'ref_dialogBusinessName');
        },

        fn_openDialogConfirmation: function(){
            this.fn_closeDialog();
            let self = this;
            setTimeout(function(){
                self.fn_openDialogWeb('web', 'DiscardDialog', 'ref_dialogConfirmation');
            },300);
        },

        fn_confirmChangeDataDrive: function(){
            this.fn_closeDialog();
            // let self = this;
            // this.showLoading("Please wait...");
            // this.fn_changeAccount();
            this.fn_restoreAllDocuments();
            // this.$root.fn_getAuthToken(function(token){
            //     self.$root.fn_getPhoneNumber(token, function(mobileNumber){
            //         self.hideLoading();
            //         self.fn_getOtp(mobileNumber);
            //     })
            // })
        },

        // fn_getOtp: function(mobileNumber){
        //     this.$router.push({
        //         name:'otpVerification', 
        //         query:{mobile_number:mobileNumber, requestType:2},
        //         params: {
        //             verifyCallback: this.fn_verifyCallback
        //         }
        //     });
        // },

        // fn_verifyCallback: function(requestId, otp){
        //     this.fn_goBack();
        //     this.hideLoading();
        //     this.fn_changeAccount(requestId, otp);
        // },

        // fn_changeAccount: function(requestId, otp){

        fn_restoreAllDocuments: function(){
            if(!navigator.onLine){
                this.showToast('Internet not available');
                return;
            }

            let self = this;
            this.showLoading('Collecting data to change drive...');
            this.getData('RestoreAllDocumentFile', this.$root.CurrentBusiness.BusinessID, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        self.hideLoading();
                        self.fn_changeAccount();
                    },
                    onError: function(error){
                        console.log(error);
                        self.hideLoading();
                        self.showToast('Something went wrong. Try again');
                    }
                }
            );
        },

        fn_changeAccount: function(){
            if(!navigator.onLine){
                this.showToast('Internet not available');
                return;
            }

            let self = this;
            this.getData('ChangeAccount', null, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        self.fn_uploadAllDocuments(response);
                    },
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },

        fn_uploadAllDocuments: function(dataDrive){
            if(!navigator.onLine){
                this.showToast('Internet not available');
                return;
            }

            let self = this;
            let filterObject = {}
            filterObject.changeDrive = true;
            filterObject.businessId = this.$root.CurrentBusiness.BusinessID;

            this.showLoading('Updating backup drive...');

            this.getFilterData('UploadAllDocumentFile', null, filterObject,
                {
                    onSuccess: function(response){
                        console.log(response);
                        self.fn_backupAllBusinessData(dataDrive);
                    },
                    onError: function(error){
                        console.log(error);
                        self.hideLoading();
                        self.showToast('Something went wrong. Try again');
                    }
                }
            );
        },

        // fn_uploadAllDocuments: function(dataDrive){
        //     if(!navigator.onLine){
        //         this.showToast('Internet not available');
        //         return;
        //     }

        //     let self = this;
        //     this.showLoading('Updating backup drive...');
        //     this.getData('UploadAllDocumentFile', this.$root.CurrentBusiness.BusinessID, 
        //         {
        //             onSuccess: function(response){
        //                 console.log(response);
        //                 self.fn_backupAllBusinessData(dataDrive);
        //             },
        //             onError: function(error){
        //                 console.log(error);
        //                 self.hideLoading();
        //                 self.showToast('Something went wrong. Try again');
        //             }
        //         }
        //     );
        // },

        // fn_backupAllBusinessData: function(dataDrive, requestId, otp){

        //     let self = this;
        //     this.showLoading('Configuring backup drive...');
        //     this.getData('BackupAllData', this.$root.CurrentBusiness.BusinessID, 
        //         {
        //             onSuccess: function(response){
        //                 console.log(response);
        //                 // self.hideLoading();
        //                 self.showToast('Data backup complete');
        //                 self.$root.fn_getAuthToken(function(token){
        //                     self.fn_changeDataDrive(dataDrive, token, requestId, otp);
        //                 })
        //             },
        //             onError: function(error){
        //                 console.log(error);
        //                 self.hideLoading();
        //                 self.showToast('Something went wrong. Try again');
        //             }
        //         }
        //     );
            
        // },

        // fn_backupAllBusinessData: function(dataDrive, requestId, otp){

        fn_backupAllBusinessData: function(dataDrive){

            let self = this;
            let filterObject = {}
            // filterObject.complexOperation = true;
            filterObject.complexOperation = false;
            filterObject.changeDrive = true;

            // this.showLoading('Configuring backup drive...');

            this.getFilterData('BackupAllData', this.$root.CurrentBusiness.BusinessID, filterObject,
                {
                    onSuccess: function(response){
                        console.log(response);
                        // self.hideLoading();
                        self.showToast('Data backup complete');
                        self.fn_reopenDatabase(dataDrive);
                        // self.$root.fn_getAuthToken(function(token){
                        //     self.fn_changeDataDrive(dataDrive, token);
                        // });
                    },
                    onError: function(error){
                        console.log(error);
                        self.hideLoading();
                        self.fn_reopenDatabase();
                        self.showToast('Something went wrong. Try again');
                    }
                }
            );
            
        },

        // fn_reopenDatabase: function(dataDrive){
        //     let self = this;
        //     this.getData('ReopenDataBase', this.$root.CurrentBusiness.BusinessID, 
        //         {
        //             onSuccess: function(response){
        //                 console.log(response);
        //                 self.$root.fn_getAuthToken(function(token){
        //                     self.fn_changeDataDrive(dataDrive, token);
        //                 }); 
        //             }, 
        //             onError: function(error){
        //                 console.log(error);
        //                 self.hideLoading();
        //                 self.showToast('Something went wrong. Try again');
        //             }
        //         }
        //     );
        // },

        // fn_changeDataDrive: function(dataDrive, token, requestId, otp){
        fn_changeDataDrive: function(dataDrive, token){

            if(!navigator.onLine){
                this.showToast('Internet not available');
                this.hideLoading();
                return;
            }
            
            let self = this;
            let filterObject = {};
            filterObject.BusinessID = this.$root.CurrentBusiness.BusinessID;
            filterObject.DataDriveLocation = dataDrive;
            filterObject.RequestID = null;
            // filterObject.RequestID = requestId;
            // filterObject.OTP = otp;
            filterObject.token = token;

            this.postServerData('SetDataDrive', filterObject, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        self.hideLoading();
                        self.$root.CurrentBusiness.DataDrive = dataDrive;
                        self.showToast('Backup drive changed');
                        self.fn_getLastBackupInfo();
                    }, 
                    onError: function(error){
                        console.log(error);
                        self.hideLoading();
                        if(typeof JSON.parse(error) == 'object'){
                            let response = JSON.parse(error);
                            self.showToast(response.Message);
                        }
                    },
                }
            );
        },

        fn_goBack: function(){
            let currentDate = this.$moment(new Date()).format('DD-MMM-YYYY');
            let lastBackupDate = this.$moment(new Date(this.lastBackupTime)).format('DD-MMM-YYYY');
            if(this.directClose && currentDate != lastBackupDate){
                if(this.$root.backupInProgress){
                    this.showToast("Please wait data backup in progress...");
                }
                else{
                    this.exitApp();
                }
            }
            else{
                this.$router.go(-1);
            }
        }

    },
    mounted: function(){
        this.formId = this.guidWeb();
        this.dialogStorageId = 'dialog_'+this.formId;
        // window.js_globals.fn_setUploadStatus = this.fn_setUploadStatus;
        window.js_globals.fn_onBackPress = this.fn_goBack;
        window.js_globals.fn_closeClick = this.fn_closeDialog;

        if(this.$route.query.exitapp){
            this.directClose = true;
        }

        if(this.$route.query && this.$route.query.changedrive){
            this.fn_checkIsBackupRunning();
        }

        if(this.$route.query && this.$route.query.auto_start){
            this.fn_prepareDataToBackup();
        }

        let self = this;
        setTimeout(function(){
            self.fn_getLastBackupInfo();
        },300)
    },
    beforeRouteLeave (to, from, next) {
        var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
        if(dialogData && dialogData.length){
            dialogjs.fn_checkAndCloseOpenDialogs(this);
            next(false);
        }
        else{
            next();
        }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/settings/backup_data/backup.vue